var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconEditorListOrdered = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("path", { d: "M14.9,7h11.8" }),
            React.createElement("path", { d: "M14.9,15h11.8" }),
            React.createElement("path", { d: "M14.9,23h11.8" }),
            React.createElement("path", { d: "M3.3,4.9v4.2" }),
            React.createElement("path", { d: "M6.7,12.9v4.2" }),
            React.createElement("path", { d: "M3.3,12.9v4.2" }),
            React.createElement("path", { d: "M6.7,20.9v4.2" }),
            React.createElement("path", { d: "M3.3,20.9v4.2" }),
            React.createElement("path", { d: "M10.1,20.9v4.2" }))));
});
export default IconEditorListOrdered;
//# sourceMappingURL=IconEditorListOrdered.js.map